module.exports = __webpack_public_path__ + "img/round.477ca4d0.svg";